import React, { Component } from 'react';
import ErrorMessageDropdown from 'app/components/base/ErrorMessageDropdown';
import CN from 'classnames';
import HelperTooltip from 'app/components/common/HelperTooltip';
import { Layout, Flex } from '../Layout';
import { isNull } from 'app/utils/types';

import styles from './style.css';


const builder = ({ FormInput }) => {
  /**
   * Input component used in User login and signup forms.
   * Has fancy label and validation transitions.
   */
  class TransitionInput extends Component {
    isDisabled = () => {
      const { disabled } = this.props.meta;
      return disabled;
    }

    isEmpty = () => {
      const { type } = this.props;
      const { value } = this.props.input;
      return isNull(value, type);
    }

    focusInputField = () => {
      if (this.inputNode && this.inputNode.focus) {
        this.inputNode.focus();
      }
    }

    renderHelper = () => {
      if (!this.isEmpty() && !this.isDisabled()) return false;
      const { helperHint, helperHintDirection } = this.props;
      return (
        <div className={styles.actionable}>
          <HelperTooltip hint={helperHint} direction={helperHintDirection} />
        </div>
      );
    }

    render() {
      const {
        className,
        labelClassName,
        errorClassName,
        children,
        label,
        placeholder,
        upwards,
        compact,
        inputClassName,
        deanimatePlaceholder,
        showHelperIcon,
        cleanable,
        raised,
        rectangled,
        keepLabel,
        notActiveLabel,
        ...props
      } = this.props;

      const labelSize = {
        '> mobile': upwards ? 100 : 33,
        'mobile': 100
      };

      const inputSize = {
        '> mobile': upwards ? 100 : 66,
        'mobile': 100
      };

      const labelPlaceholder = placeholder || label;
      const inputPlaceholder = rectangled ? placeholder : '';

      const filled = !isNull(props.input.value, props.type) || props.prefix;

      return (
        <ErrorMessageDropdown className={errorClassName} {...props}>
          <Layout
            size="noshrink"
            onClick={this.focusInputField}
            className={CN({
              [styles.sideways]: !upwards,
              [styles.raised]: raised,
              [styles.keepLabel]: keepLabel,
              [styles.focused]: this.props.meta.active,
              [styles.filled]: filled,
              [styles.notActiveLabel]: notActiveLabel,
              [styles.compact]: compact,
              [styles['deanimate-placeholder']]: deanimatePlaceholder,
              [styles.rectangled]: rectangled
            }, className, styles.container)}
          >
            {!!label && (
              <Flex size={labelSize} className={CN(styles.label, labelClassName)}>
                {label}
              </Flex>
            )}
            <Flex size={inputSize} className={styles.field}>
              <Layout nowrap align="center stretch" size="noshrink">
                <Layout
                  className={styles.placeholderContainer}
                  size="noshrink"
                  align="start center"
                >
                  {children}
                  <label className={styles.placeholder}>
                    {labelPlaceholder}
                  </label>
                </Layout>
                <Flex size="grow" className={styles.inputWrapper}>
                  <FormInput
                    {...props}
                    placeholder={inputPlaceholder}
                    cleanable={props.type === 'text' ? true : cleanable}
                    ref={node => this.inputNode = node}
                    className={CN(styles.input, inputClassName)}
                  />
                  <span className={styles.grayBar}></span>
                </Flex>
              </Layout>
              <span className={styles.bar}></span>
              <span className={styles.highlight}></span>
              {showHelperIcon && this.renderHelper()}
            </Flex>
          </Layout>
        </ErrorMessageDropdown>
      );
    }
  }

  // TODO: move to Flow types
  // TransitionInput.propTypes = {
  //   className: PropTypes.string,
  //   labelClassName: PropTypes.string,
  //   errorClassName: PropTypes.string,
  //   meta: PropTypes.object,
  //   input: PropTypes.object,
  //   inputClassName: PropTypes.string,
  //   children: PropTypes.node,
  //   upwards: PropTypes.bool,
  //   onClear: PropTypes.func,
  //   type: PropTypes.string,
  //   label: PropTypes.node,
  //   placeholder: PropTypes.node,
  //   compact: PropTypes.bool,
  //   raised: PropTypes.bool,
  //   rectangled: PropTypes.bool,
  //   deanimatePlaceholder: PropTypes.bool,
  //   showHelperIcon: PropTypes.bool,
  //   helperHintDirection: PropTypes.oneOf(DROPDOWN_DIRECTIONS),
  //   helperHint: PropTypes.any,
  //   cleanable: PropTypes.bool,
  //   keepLabel: PropTypes.bool,
  //   notActiveLabel: PropTypes.bool
  // };

  return TransitionInput;
};

export default builder;
